import { render, staticRenderFns } from "./appDefaultLogo2.vue?vue&type=template&id=01e5851b"
import script from "./appDefaultLogo2.vue?vue&type=script&lang=js"
export * from "./appDefaultLogo2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports